export interface Milestone {
    year: string
    title: string
    text: string
}

export const milestones: Array<Milestone> = [
    { year: '2019', title: "Founded in Rotterdam", text: "Elin and Joris connect their first carrier to an ERP over a weekend." },
    { year: '2020', title: "First managed flow", text: "A food importer goes live with bookings, customs and receipts in one flow." },
    { year: '2021', title: "1,000 connections", text: "Carriers, ports and brokers across Europe and North America." },
    { year: '2022', title: "Ops desk goes 24/7", text: "Shifts in Rotterdam, Chicago and Singapore follow the sun." },
    { year: '2023', title: "Flow Studio launches", text: "Customers start building and changing flows themselves." },
    { year: '2024', title: "Open API", text: "One key to the whole network for engineering teams." },
    { year: '2025', title: "Pilot joins the team", text: "An AI teammate for the repetitive parts of daily ops." },
    { year: '2026', title: "Freight Tech 100", text: "Named to the list, with 3,400+ connections live." }
]

export interface Value {
    title: string
    text: string
}

export const values: Array<Value> = [
    { title: "Calm under pressure", text: "Freight goes wrong at the worst moments. We stay level and fix the problem in front of us." },
    { title: "Exceptions are the job", text: "Anyone can automate the happy path. We design for the shipment that does not follow it." },
    { title: "Plain language", text: "No jargon in updates, contracts or code reviews. If it cannot be said simply, it is not ready." },
    { title: "Own the outcome", text: "A flow is not done when it is built. It is done when the freight arrives." },
    { title: "Small team, long memory", text: "We keep notes on every lane, so a fix we found once is never lost." },
    { title: "Leave it better", text: "Every exception we handle should make the next one less likely." }
]

export interface TeamMember {
    name: string
    role: string
    location: string
    tint: string
}

export const team: Array<TeamMember> = [
    { name: "Elin Vos", role: "Co-founder and CEO", location: "Rotterdam", tint: 'linear-gradient(135deg, #ffd9c7, #f6e6da)' },
    { name: "Joris de Haan", role: "Co-founder and CTO", location: "Rotterdam", tint: 'linear-gradient(135deg, #e3dcfb, #eee9f7)' },
    { name: "Priya Natarajan", role: "Head of Operations", location: "Singapore", tint: 'linear-gradient(135deg, #d6eafc, #e9f1f7)' },
    { name: "Ana Ruiz", role: "Solutions Engineering", location: "Chicago", tint: 'linear-gradient(135deg, #f6e6c4, #f7eedd)' },
    { name: "Tomas Lindqvist", role: "Customs Lead", location: "Hamburg", tint: 'linear-gradient(135deg, #d6f0df, #e8f4eb)' },
    { name: "Marcus Webb", role: "Delivery Lead", location: "London", tint: 'linear-gradient(135deg, #ffe0d1, #efe3f5)' },
    { name: "Grace Mensah", role: "Customer Success", location: "Chicago", tint: 'linear-gradient(135deg, #e6e7ff, #f1ebf8)' },
    { name: "Kenji Morita", role: "Platform Engineering", location: "Rotterdam", tint: 'linear-gradient(135deg, #e9f0d8, #f4f0e2)' }
]

export const companyStats: Array<{ value: string, label: string }> = [
    { value: '64', label: "people in five cities" },
    { value: '3,400+', label: "live connections in the network" },
    { value: '31', label: "countries our customers ship from" },
    { value: '24/7', label: "operations desk, staffed by people" }
]

export interface PartnerType {
    title: string
    text: string
}

export const partnerTypes: Array<PartnerType> = [
    { title: "Carriers and ports", text: "Join the network once and reach every Quayside customer with the same clean booking and event data." },
    { title: "Customs brokers", text: "Receive complete, checked entry data days before arrival, and answer holds with the shipment already open." },
    { title: "Software vendors", text: "Offer your customers freight connections without building and maintaining them yourself." }
]
